import useMutation from '@space-shell/common/hooks/useMutation'
import type { CommunityGroupGetResponse } from '@space-shell/common/services/communities'
import { CommunitiesEndpoints, CommunitiesService } from '@space-shell/common/services/communities'
import { queryClient } from '@space-shell/config/request'

export const useSetLastViewDate = () => {
  return {
    setLastViewDateQuery: useMutation<unknown, number>((communityId) =>
      CommunitiesService.setLastViewDate(communityId)
    ),
    invalidateCommunitiesQueries: (membershipSlug: string, communityId: number) => {
      const previousGroupCommunities = queryClient.getQueryData<CommunityGroupGetResponse>([
        CommunitiesEndpoints.getGroupCommunities(membershipSlug)
      ])

      const newGroupCommunities = previousGroupCommunities?.map((group) => ({
        ...group,
        communities: {
          ...group.communities,
          data: group.communities.data.map((community) => ({
            ...community,
            hasUnseenNewsOrCommentReplies:
              community.id === communityId ? false : community.hasUnseenNewsOrCommentReplies
          }))
        }
      }))

      queryClient.setQueryData(
        [CommunitiesEndpoints.getGroupCommunities(membershipSlug)],
        newGroupCommunities
      )

      queryClient.setQueryData(
        [CommunitiesEndpoints.getGroupCommunitiesPublic(membershipSlug)],
        newGroupCommunities
      )
    }
  }
}
